import { useState } from 'react';
import PropTypes from 'prop-types';

import CardModule from '../../shared/card-module';
import Button from 'react-bootstrap/Button';
import ModalBasic from '../../../atoms/modal-basic';

import { className, get as gs } from '../../../../utils/GlobalCssProxy';

const TextModule = ({
  moduleHeader,
  textHighlighted,
  textNormal,
  modalText,
  analyticsId,
  disablePrintSizeClass
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleShow = () => setIsModalVisible(true);
  const handleClose = () => setIsModalVisible(false);
  const hasPrintFontSizeClass = disablePrintSizeClass ? null : 'print-font-size';

  return (
    <CardModule
      data-analytics-componenttype="half-width-component"
      data-analytics-id={`HW_${analyticsId}`}
      data-analytics-section="component"
    >
      <CardModule.Header>{moduleHeader}</CardModule.Header>
      <CardModule.Body>
        {textHighlighted && (
          <p {...className('paragraph-emphasized', hasPrintFontSizeClass)}>{textHighlighted}</p>
        )}
        {textNormal && (
          <p {...className('paragraph-standard', hasPrintFontSizeClass)}>{textNormal}</p>
        )}
        {modalText && (
          <>
            <Button
              variant="link--reverse-underline"
              onClick={handleShow}
              className={gs('text-black', 'p-0', 'd-inline', 'd-print-none')}
            >
              View more information
            </Button>
            <p {...className('d-print-block', 'd-none')}> {modalText}</p>
          </>
        )}
      </CardModule.Body>
      {modalText && (
        <ModalBasic show={isModalVisible} onHide={handleClose}>
          <ModalBasic.Header>
            <ModalBasic.Title>{moduleHeader}</ModalBasic.Title>
            <ModalBasic.CloseButton onClick={handleClose} />
          </ModalBasic.Header>
          <ModalBasic.Body>
            {/*Bootstrap modal body doesn't seem to accept strings with HTML tags in them, so doing it this way*/}
            {modalText.map((modalSection, index) => {
              return (
                <p
                  data-key={`${modalSection || ''}-${index}`}
                  key={`${modalSection || ''}-${index}`}
                  {...className('print-font-size')}
                >
                  {modalSection}
                </p>
              );
            })}
          </ModalBasic.Body>
        </ModalBasic>
      )}
    </CardModule>
  );
};

TextModule.propTypes = {
  analyticsId: PropTypes.string,
  textHighlighted: PropTypes.string,
  textNormal: PropTypes.string,
  modalText: PropTypes.array,
  moduleHeader: PropTypes.string,
  disablePrintSizeClass: PropTypes.bool
};

export default TextModule;
